import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListDocumentsComponent } from './pages/list-documents/list-documents.component';
import { FormComponent } from './pages/form/form.component';
import { SearchComponent } from './pages/search/search.component';
import { ReportComponent } from './pages/report/report.component';
import { SharedModule } from '@app/shared/shared.module';
import { httpInterceptorProviders } from '@app/auth/interceptors';



@NgModule({
  declarations: [ListDocumentsComponent, FormComponent, SearchComponent, ReportComponent],
  imports: [CommonModule, SharedModule],
  exports: [],
  providers: [httpInterceptorProviders],
})
export class DocumentsModule { }
